import * as React from 'react';
import toArray from 'rc-util/lib/Children/toArray';
import { ConfigContext } from '../config-provider';
import useFlexGapSupport from '../_util/hooks/useFlexGapSupport';
const Space = props => {
    const { prefixCls: customizePrefixCls, space = 12, children } = props;
    const supportFlexGap = useFlexGapSupport();
    const spaceStyle = {};
    let childrenMap = children;
    if (!supportFlexGap) {
        const childNodes = toArray(children, { keepEmpty: true });
        childrenMap = childNodes.map((child, index) => {
            return (<span style={{ marginRight: index === childNodes.length - 1 ? 0 : space }}>
                {child}
            </span>);
        });
    }
    if (supportFlexGap) {
        spaceStyle.columnGap = space;
    }
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('table-space', customizePrefixCls);
    return (<div className={prefixCls} style={spaceStyle}>
            {childrenMap}
        </div>);
};
export default Space;
